import BrowserProvider from './browser';
import XHRProvider from './browser/xhr';

export default {
  Browser: BrowserProvider,
  XHR: XHRProvider
};



// WEBPACK FOOTER //
// ./src/providers/index.js